"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePageSizeSelectOptions = exports.range = exports.getPageSizeOptions = exports.defaultPageSizeOptions = exports.DOTS = void 0;
var _react = require("react");
const DOTS = exports.DOTS = '...';
const range = (start, end) => {
  const range = [];
  for (let i = start; i <= end; i++) {
    range.push(i);
  }
  return range;
};
exports.range = range;
const defaultPageSizeOptions = exports.defaultPageSizeOptions = [10, 20, 30, 50];
const getPageSizeOptions = pageSizeOptions => {
  return pageSizeOptions.map(pageSize => ({
    label: pageSize.toString(),
    value: pageSize.toString()
  }));
};
exports.getPageSizeOptions = getPageSizeOptions;
const usePageSizeSelectOptions = pageSizeOptions => (0, _react.useMemo)(() => getPageSizeOptions(pageSizeOptions), [pageSizeOptions]);
exports.usePageSizeSelectOptions = usePageSizeSelectOptions;